module.exports = __webpack_public_path__ + "static/media/haircut_map.688629ba.svg";